/* eslint-disable react/jsx-key */
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useState } from 'react';
import { TextField, CircularProgress } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RingMenuOptions from './ring_menu_options.component';
import DeleteRingModal from './ring_delete_modal.component';

export const RingRoutesListComponent = ({
  allRingGroups = [],
  onRingSelect,
  selectedRingId,
  loadingRingId,
  loadingRingGroups = false,
  onRefresh,
  onAddCost,
  onEdit,
  onAudit,
  onExport,
}) => {
  const [search, setSearch] = useState('');
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedRingForAction, setSelectedRingForAction] = useState(null);

  const handleSelectRing = (id) => {
    if (selectedRingId === id) {
      onRingSelect(null);
    } else {
      onRingSelect(id);
    }
  };

  const handleInputChange = (event) => {
    setSearch(event.target.value);
  };

  const filteredRings = search
    ? allRingGroups?.filter((ring) => ring.name.toLowerCase().includes(search.toLowerCase()))
    : allRingGroups;

  const handleDelete = (ring) => {
    setSelectedRingForAction(ring);
    setOpenDeleteModal(true);
  };

  const handleDeleteSuccess = async () => {
    // If the deleted ring was selected, clear the selection
    if (selectedRingForAction?.id === selectedRingId) {
      onRingSelect(null);
    }

    // Refresh the ring groups list after successful deletion
    if (onRefresh) {
      await onRefresh();
    }

    setSelectedRingForAction(null);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
    setSelectedRingForAction(null);
  };

  const handleAddCost = (ring) => {
    if (onAddCost) {
      onAddCost(ring);
    }
  };

  return (
    <>
      <div className="drawer-content" style={{ height: '85vh', marginTop: '5%' }}>
        <div className="alerts_list_main" style={{ height: '82vh', width: 380 }}>
          <PerfectScrollbar>
            <div style={{ padding: '5px', display: 'grid', gap: '10px' }}>
              {/* Heading */}
              <div
                style={{
                  width: 344,
                  paddingLeft: 12,
                  paddingRight: 12,
                  paddingTop: 8,
                  paddingBottom: 8,
                  borderBottom: '1px solid #E5E9EB',
                }}
              >
                <div
                  style={{
                    color: '#192126',
                    fontSize: 20,
                    fontFamily: 'Poppins',
                    fontWeight: '500',
                    wordWrap: 'break-word',
                  }}
                >
                  Rings
                </div>
              </div>

              {/* Search Field */}
              <div
                style={{
                  width: 344,
                  paddingLeft: 12,
                  paddingRight: 12,
                  paddingTop: 0,
                  paddingBottom: 8,
                }}
              >
                <TextField
                  variant="outlined"
                  placeholder="Search Rings..."
                  value={search}
                  size="small"
                  fullWidth
                  onChange={handleInputChange}
                  InputProps={{
                    style: {
                      fontSize: 14,
                      fontFamily: 'Poppins',
                      fontWeight: 500,
                      color: '#757F82',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    },
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: '#C4C4C4',
                      },
                      '&:hover fieldset': {
                        borderColor: '#A0A0A0',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#C4C4C4',
                      },
                    },
                  }}
                  title={search}
                />
              </div>

              <div
                style={{
                  width: 344,
                  boxSizing: 'border-box',
                  paddingLeft: 12,
                  paddingRight: 12,
                  paddingBottom: 16,
                  background: 'white',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  gap: 24,
                  display: 'inline-flex',
                }}
              >
                {loadingRingGroups ? (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '200px',
                      flexDirection: 'column',
                      gap: '16px',
                    }}
                  >
                    <CircularProgress
                      size={40}
                      sx={{
                        color: '#BD1D23',
                      }}
                    />
                    <div
                      style={{
                        color: '#757F82',
                        fontSize: 14,
                        fontFamily: 'Poppins',
                        fontWeight: 500,
                      }}
                    >
                      Loading Ring Groups...
                    </div>
                  </div>
                ) : filteredRings?.length ? (
                  <div
                    style={{
                      alignSelf: 'stretch',
                      height: 418,
                      flexDirection: 'column',
                      justifyContent: 'flex-start',
                      alignItems: 'flex-start',
                      gap: 16,
                      display: 'flex',
                    }}
                  >
                    {filteredRings?.map((ring) => {
                      const isSelected = selectedRingId === ring.id;
                      return (
                        <div
                          key={ring.id}
                          onClick={() => handleSelectRing(ring.id)}
                          style={{
                            alignSelf: 'stretch',
                            minHeight: 200,
                            padding: '16px',
                            background: isSelected
                              ? 'linear-gradient(135deg, #FFF5F5 0%, #FFEBEE 100%)'
                              : 'linear-gradient(135deg, #FFFFFF 0%, #FAFAFA 100%)',
                            boxShadow: isSelected
                              ? '0px 8px 24px rgba(189, 29, 35, 0.15), 0px 4px 8px rgba(0, 0, 0, 0.1)'
                              : '0px 4px 12px rgba(0, 0, 0, 0.08), 0px 2px 4px rgba(0, 0, 0, 0.04)',
                            border: isSelected ? '2px solid #BD1D23' : '1px solid #E0E0E0',
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            alignItems: 'flex-start',
                            gap: 12,
                            display: 'flex',
                            cursor: 'pointer',
                            borderRadius: 16,
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            transform: 'scale(1)',
                            position: 'relative',
                            overflow: 'hidden',
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'scale(1.02)';
                            e.currentTarget.style.boxShadow = isSelected
                              ? '0px 12px 32px rgba(189, 29, 35, 0.2), 0px 6px 12px rgba(0, 0, 0, 0.15)'
                              : '0px 8px 20px rgba(0, 0, 0, 0.12), 0px 4px 8px rgba(0, 0, 0, 0.08)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.boxShadow = isSelected
                              ? '0px 8px 24px rgba(189, 29, 35, 0.15), 0px 4px 8px rgba(0, 0, 0, 0.1)'
                              : '0px 4px 12px rgba(0, 0, 0, 0.08), 0px 2px 4px rgba(0, 0, 0, 0.04)';
                          }}
                        >
                          <div
                            style={{
                              alignSelf: 'stretch',
                              justifyContent: 'flex-start',
                              alignItems: 'flex-start',
                              gap: 8,
                              display: 'inline-flex',
                            }}
                          >
                            <div
                              style={{
                                flex: '1 1 0',
                                flexDirection: 'column',
                                justifyContent: 'flex-start',
                                alignItems: 'flex-start',
                                gap: 0,
                                display: 'inline-flex',
                              }}
                            >
                              {/* Ring Name Header */}
                              <div
                                style={{
                                  alignSelf: 'stretch',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  display: 'inline-flex',
                                  marginBottom: 8,
                                }}
                              >
                                <div
                                  style={{
                                    color: '#192126',
                                    fontSize: 16,
                                    fontFamily: 'Poppins',
                                    fontWeight: '600',
                                    wordWrap: 'break-word',
                                    maxWidth: 200,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                  }}
                                  title={ring.name}
                                >
                                  {ring.name}
                                </div>

                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                  }}
                                >
                                  {isSelected && (
                                    <div
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                      }}
                                    >
                                      {loadingRingId === ring.id ? (
                                        <CircularProgress
                                          size={16}
                                          sx={{
                                            color: '#BD1D23',
                                          }}
                                        />
                                      ) : (
                                        <VisibilityIcon
                                          sx={{
                                            fontSize: 16,
                                            color: '#BD1D23',
                                          }}
                                          title="Visible on map"
                                        />
                                      )}
                                      <AddCircleOutlineIcon
                                        sx={{
                                          fontSize: 16,
                                          color: '#BD1D23',
                                          cursor: 'pointer',
                                        }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleAddCost(ring);
                                        }}
                                        title="Add Cost"
                                      />
                                    </div>
                                  )}
                                  <RingMenuOptions
                                    ring={ring}
                                    onDelete={handleDelete}
                                    onEdit={onEdit}
                                    onAudit={onAudit}
                                    onExport={onExport}
                                    onAddCost={handleAddCost}
                                  />
                                </div>
                              </div>

                              {/* Stats Chips Container */}
                              <div
                                style={{
                                  display: 'flex',
                                  flexWrap: 'wrap',
                                  gap: '8px',
                                  alignSelf: 'stretch',
                                }}
                              >
                                {/* Length Chip */}
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    padding: '6px 12px',
                                    background: 'linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%)',
                                    borderRadius: '20px',
                                    border: '1px solid #90CAF9',
                                    boxShadow: '0px 2px 4px rgba(33, 150, 243, 0.1)',
                                  }}
                                >
                                  <div
                                    style={{
                                      width: '8px',
                                      height: '8px',
                                      borderRadius: '50%',
                                      background: '#2196F3',
                                    }}
                                  />
                                  <div
                                    style={{
                                      color: '#1565C0',
                                      fontSize: 11,
                                      fontFamily: 'Poppins',
                                      fontWeight: '600',
                                    }}
                                  >
                                    Length
                                  </div>
                                  <div
                                    style={{
                                      color: '#0D47A1',
                                      fontSize: 11,
                                      fontFamily: 'Poppins',
                                      fontWeight: '700',
                                    }}
                                    title={`${ring.totalLength?.toLocaleString()} meters`}
                                  >
                                    {ring.totalLength?.toLocaleString()}m
                                  </div>
                                </div>

                                {/* Cost Chip */}
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    padding: '6px 12px',
                                    background: 'linear-gradient(135deg, #E8F5E8 0%, #C8E6C9 100%)',
                                    borderRadius: '20px',
                                    border: '1px solid #81C784',
                                    boxShadow: '0px 2px 4px rgba(76, 175, 80, 0.1)',
                                  }}
                                >
                                  <div
                                    style={{
                                      width: '8px',
                                      height: '8px',
                                      borderRadius: '50%',
                                      background: '#4CAF50',
                                    }}
                                  />
                                  <div
                                    style={{
                                      color: '#2E7D32',
                                      fontSize: 11,
                                      fontFamily: 'Poppins',
                                      fontWeight: '600',
                                    }}
                                  >
                                    Cost
                                  </div>
                                  <div
                                    style={{
                                      color: '#1B5E20',
                                      fontSize: 11,
                                      fontFamily: 'Poppins',
                                      fontWeight: '700',
                                    }}
                                    title={ring.totalCost?.toLocaleString()}
                                  >
                                    {ring.totalCost?.toLocaleString()}
                                  </div>
                                </div>

                                {/* Routes Chip */}
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    padding: '6px 12px',
                                    background: 'linear-gradient(135deg, #FFF3E0 0%, #FFE0B2 100%)',
                                    borderRadius: '20px',
                                    border: '1px solid #FFB74D',
                                    boxShadow: '0px 2px 4px rgba(255, 152, 0, 0.1)',
                                  }}
                                >
                                  <div
                                    style={{
                                      width: '8px',
                                      height: '8px',
                                      borderRadius: '50%',
                                      background: '#FF9800',
                                    }}
                                  />
                                  <div
                                    style={{
                                      color: '#E65100',
                                      fontSize: 11,
                                      fontFamily: 'Poppins',
                                      fontWeight: '600',
                                    }}
                                  >
                                    Routes
                                  </div>
                                  <div
                                    style={{
                                      color: '#BF360C',
                                      fontSize: 11,
                                      fontFamily: 'Poppins',
                                      fontWeight: '700',
                                    }}
                                    title={`${ring.routeCount} routes`}
                                  >
                                    {ring.routeCount}
                                  </div>
                                </div>
                              </div>

                              {/* Description */}
                              <div
                                style={{
                                  alignSelf: 'stretch',
                                  marginTop: 8,
                                  padding: '8px 12px',
                                  background: 'linear-gradient(135deg, #F5F5F5 0%, #EEEEEE 100%)',
                                  borderRadius: '12px',
                                  border: '1px solid #E0E0E0',
                                  boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.05)',
                                  position: 'relative',
                                }}
                              >
                                <div
                                  style={{
                                    color: '#424242',
                                    fontSize: 11,
                                    fontFamily: 'Poppins',
                                    fontWeight: '600',
                                    marginBottom: 4,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px',
                                  }}
                                >
                                  Description
                                </div>
                                <div
                                  style={{
                                    color: '#616161',
                                    fontSize: 12,
                                    fontFamily: 'Poppins',
                                    fontWeight: 400,
                                    lineHeight: '1.4',
                                    maxHeight: '36px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    cursor: 'help',
                                    width: '100%',
                                    minWidth: 0,
                                  }}
                                  onMouseEnter={(e) => {
                                    if (!ring.description) {
                                      return;
                                    }

                                    const tooltip = document.createElement('div');
                                    tooltip.id = 'description-tooltip';
                                    tooltip.style.cssText = `
                                      position: fixed;
                                      background: #2C2C2C;
                                      color: white;
                                      padding: 8px 12px;
                                      border-radius: 8px;
                                      font-size: 12px;
                                      font-family: 'Poppins', sans-serif;
                                      max-width: 300px;
                                      word-wrap: break-word;
                                      z-index: 9999;
                                      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.3);
                                      pointer-events: none;
                                      opacity: 0;
                                      transition: opacity 0.2s ease;
                                    `;
                                    tooltip.textContent = ring.description;
                                    document.body.appendChild(tooltip);

                                    // Position tooltip
                                    const rect = e.target.getBoundingClientRect();
                                    tooltip.style.left = `${rect.left + rect.width / 2 - 150}px`;
                                    tooltip.style.top = `${rect.top - 10}px`;

                                    // Show tooltip
                                    setTimeout(() => {
                                      tooltip.style.opacity = '1';
                                    }, 10);
                                  }}
                                  onMouseLeave={() => {
                                    const tooltip = document.getElementById('description-tooltip');
                                    if (tooltip) {
                                      tooltip.style.opacity = '0';
                                      setTimeout(() => {
                                        if (tooltip.parentNode) {
                                          tooltip.parentNode.removeChild(tooltip);
                                        }
                                      }, 200);
                                    }
                                  }}
                                >
                                  {ring.description
                                    ? ring.description.length > 40
                                      ? `${ring.description.substring(0, 40)}...`
                                      : ring.description
                                    : 'No description available'}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '200px',
                      color: '#757F82',
                      fontSize: 14,
                      fontFamily: 'Poppins',
                      fontWeight: 500,
                    }}
                  >
                    No Ring Groups Available
                  </div>
                )}
              </div>
            </div>
          </PerfectScrollbar>
        </div>
      </div>

      {/* Delete Modal */}
      <DeleteRingModal
        open={openDeleteModal}
        onClose={handleCloseDeleteModal}
        selectedRing={selectedRingForAction}
        onDeleteSuccess={handleDeleteSuccess}
      />
    </>
  );
};
